import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useAppLoad } from "../../appLoadContext";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { BasePlainResource } from "@ploy-lib/rest-resources";
import { useResource } from "@rest-hooks/core";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
addRegisteredSectionLayout({
    name: "CommisionSection",
    displayName: "CommisionSection",
    settings: {}
});
class ComissionSummaryResource extends BasePlainResource {
    constructor() {
        super(...arguments);
        this.RevisionDate = null;
        this.TotalPayoutsVendor = 0;
    }
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: 0
            //invalidIfStale: true
        };
    }
}
ComissionSummaryResource.urlRoot = legacyApiResourceUrl("Commission/Summary");
const CommisionSection = (props) => {
    const { className, onClick } = props;
    return (_jsx(Box, { p: 2, mb: 2, clone: true, children: _jsx(Paper, { className: className, onClick: onClick, children: _jsxs(Grid, { container: true, spacing: 2, wrap: "wrap", justifyContent: "space-between", children: [_jsx(Grid, { item: true, component: Typography, children: _jsx(FormattedMessage, { id: "template-form.sections.commissions.column-totals", defaultMessage: "Totalt bel\u00F8p, forhandler" }) }), _jsx(Grid, { item: true, component: Typography, children: _jsx(Suspense, { fallback: _jsx(Skeleton, { variant: "text", width: "4ch" }), children: _jsx(CommissionValue, { name: "TotalPayoutsVendor", children: value => (_jsx(FormattedNumber, { format: "currency", value: value ?? 0 })) }) }) })] }) }) }));
};
function CommissionValue(props) {
    const appLoad = useAppLoad();
    const commissionSummary = useResource(ComissionSummaryResource.detail(), appLoad.id ? {} : null);
    return props.children(commissionSummary?.[props.name]);
}
CommisionSection.displayName = "DployCommisionSection";
export { CommisionSection };
//# sourceMappingURL=CommisionSection.js.map